export default "__VITE_ASSET__DicEelpZ__"